import { render, staticRenderFns } from "./DefaultMultiField.vue?vue&type=template&id=2d4ed702"
import script from "./DefaultMultiField.vue?vue&type=script&lang=js"
export * from "./DefaultMultiField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports